__turbopack_context__.v({
  "aboutbox1": "successful-candidates-module__zsjroG__aboutbox1",
  "aboutheading1": "successful-candidates-module__zsjroG__aboutheading1",
  "aboutheading2": "successful-candidates-module__zsjroG__aboutheading2",
  "aboutnumber": "successful-candidates-module__zsjroG__aboutnumber",
  "aboutparagraph1": "successful-candidates-module__zsjroG__aboutparagraph1",
  "acheivergreyrank": "successful-candidates-module__zsjroG__acheivergreyrank",
  "acheivername": "successful-candidates-module__zsjroG__acheivername",
  "acheiverrank": "successful-candidates-module__zsjroG__acheiverrank",
  "acheiverrank1": "successful-candidates-module__zsjroG__acheiverrank1",
  "active": "successful-candidates-module__zsjroG__active",
  "cardBox": "successful-candidates-module__zsjroG__cardBox",
  "courseborder": "successful-candidates-module__zsjroG__courseborder",
  "coursesimg": "successful-candidates-module__zsjroG__coursesimg",
  "dot": "successful-candidates-module__zsjroG__dot",
  "heading3d": "successful-candidates-module__zsjroG__heading3d",
  "heroCard": "successful-candidates-module__zsjroG__heroCard",
  "imagee": "successful-candidates-module__zsjroG__imagee",
  "leftBox": "successful-candidates-module__zsjroG__leftBox",
  "nav-item": "successful-candidates-module__zsjroG__nav-item",
  "nav-link": "successful-candidates-module__zsjroG__nav-link",
  "nav-pills": "successful-candidates-module__zsjroG__nav-pills",
  "nav-tabs": "successful-candidates-module__zsjroG__nav-tabs",
  "pagemaintitle": "successful-candidates-module__zsjroG__pagemaintitle",
  "redText": "successful-candidates-module__zsjroG__redText",
  "rightBox": "successful-candidates-module__zsjroG__rightBox",
  "scrollcontent": "successful-candidates-module__zsjroG__scrollcontent",
  "sectionblacktitle1": "successful-candidates-module__zsjroG__sectionblacktitle1",
  "sectionredtitle": "successful-candidates-module__zsjroG__sectionredtitle",
  "sectionsubtitle": "successful-candidates-module__zsjroG__sectionsubtitle",
  "sectiontitle": "successful-candidates-module__zsjroG__sectiontitle",
  "selectbox": "successful-candidates-module__zsjroG__selectbox",
  "show": "successful-candidates-module__zsjroG__show",
  "steve": "successful-candidates-module__zsjroG__steve",
  "successbox": "successful-candidates-module__zsjroG__successbox",
  "tabactive": "successful-candidates-module__zsjroG__tabactive",
  "tablinks": "successful-candidates-module__zsjroG__tablinks",
  "tabscrollclass": "successful-candidates-module__zsjroG__tabscrollclass",
  "tabsection": "successful-candidates-module__zsjroG__tabsection",
  "toppersupsc": "successful-candidates-module__zsjroG__toppersupsc",
  "widthmax": "successful-candidates-module__zsjroG__widthmax",
});
